import React from 'react'
import { FaGlobe,  FaHive } from "react-icons/fa";
import Title from '../layouts/Title';
import Card from './Card';

const Features = () => {
  return (
    <section
      id="features"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <Title title="Features" des="What I Do" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
      <Card
      title="Web Development"
      des="I excel in crafting dynamic and user-friendly web applications, from front-end 
      interfaces to server-side logic. With a deep understanding of web technologies and a 
      keen eye for design, I'm dedicated to delivering top-notch digital experiences that 
      engage and delight users."
      icon={<FaGlobe />}
      />


      <Card
      title="Software Development"
      des="I specialize in creating efficient and innovative software solutions that meet 
      your business needs. With a passion for coding and problem-solving, I bring your ideas
      to life through clean and maintainable code. Let's work together to build the software 
      that drives your success."
      icon={< FaHive/>}
      />

       
            
      <Card
        title="Hosting Websites"
        des="I specialize in providing reliable and secure web hosting solutions. Your website's 
        performance and uptime are my top priorities. With state-of-the-art infrastructure and a 
        commitment to data security, I ensure your online presence is always accessible and 
        responsive to your audience."
        icon={<FaGlobe />}
      />

      </div>
    </section>
  );
}

export default Features